var _path, _path2, _path3, _path4, _g, _path5, _g2, _path6, _g3, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSlide3Planets(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 812,
    height: 546,
    viewBox: "0 0 812 546",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M348.596 536.555V537.434C348.596 537.635 348.596 537.942 348.496 538.143C348.395 538.651 348.194 539.223 348.088 539.731C347.987 540.033 347.786 540.441 347.58 540.711C346.802 542.198 345.584 543.485 344.197 544.294C342.71 545.173 341.122 545.581 339.428 545.581C337.734 545.581 336.146 545.073 334.658 544.093C333.271 543.215 332.091 541.928 331.376 540.34C331.175 539.832 330.968 539.361 330.767 538.752C330.667 538.551 330.667 538.344 330.566 538.043C330.465 537.741 330.465 537.434 330.465 537.164C330.365 536.185 330.465 535.168 330.767 534.189C330.868 533.887 330.968 533.58 331.069 533.411C331.169 533.109 331.27 532.903 331.371 532.701C331.471 532.601 331.471 532.4 331.572 532.294C331.773 531.886 331.979 531.516 332.281 531.214C333.059 530.134 334.076 529.218 335.357 528.541C336.543 527.932 337.824 527.561 339.211 527.461C340.597 527.36 341.884 527.662 343.165 528.17C344.451 528.678 345.531 529.557 346.447 530.536C346.855 530.944 347.156 531.415 347.426 531.923C347.527 532.124 347.728 532.431 347.834 532.633C347.934 532.934 348.035 533.141 348.136 533.411C348.374 534.596 348.575 535.576 348.575 536.555H348.596Z",
    fill: "url(#paint0_linear_7761_84917)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8392 245.108C91.1401 245.108 98.6782 237.57 98.6782 228.269C98.6782 218.968 91.1401 211.43 81.8392 211.43C72.5382 211.43 65.0001 218.973 65.0001 228.269C64.9683 237.57 72.5065 245.108 81.8392 245.108Z",
    fill: "url(#paint1_linear_7761_84917)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0218 532.153C41.7308 532.153 51.2229 522.661 51.2229 510.952C51.2229 499.243 41.7308 489.751 30.0218 489.751C18.3128 489.751 8.8208 499.243 8.8208 510.952C8.8208 522.661 18.3128 532.153 30.0218 532.153Z",
    fill: "url(#paint2_linear_7761_84917)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7761_84917",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 489,
    width: 44,
    height: 44
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6706 525.164C53.5237 516.479 52.8492 503.072 44.1642 495.219C35.4791 487.366 22.0723 488.041 14.2192 496.726C6.36616 505.411 7.04065 518.818 15.7257 526.671C24.4108 534.524 37.8175 533.849 45.6706 525.164Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7761_84917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9867 546.525C20.0434 535.504 22.1079 525.764 24.3048 514.843C26.1629 505.479 26.2317 495.4 20.2446 487.454C16.592 482.621 8.57739 487.692 12.23 492.562C18.7571 501.217 15.0039 512.037 13.1088 521.709C11.2507 531.073 11.4518 540.274 13.9557 549.469C15.5438 555.35 24.6065 552.375 22.9867 546.525Z",
    fill: "url(#paint3_linear_7761_84917)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7761_84917",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 489,
    width: 44,
    height: 44
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6706 525.164C53.5237 516.479 52.8492 503.072 44.1642 495.219C35.4791 487.366 22.0723 488.041 14.2192 496.726C6.36616 505.411 7.04065 518.818 15.7257 526.671C24.4108 534.524 37.8175 533.849 45.6706 525.164Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7761_84917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.7818 546.525C34.9238 535.128 37.5917 524.176 40.0639 513.117C41.112 508.316 42.6313 503.208 41.9219 498.237C41.0432 492.588 37.1894 488.327 33.2668 484.51C28.9366 480.148 22.6478 487.247 26.9092 491.577C31.1706 495.871 33.198 499.253 32.0175 505.473C31.07 510.142 29.9901 514.774 28.9419 519.47C27.0151 528.532 25.7975 537.796 27.3168 546.997C28.2961 552.947 37.7982 552.608 36.7871 546.525H36.7818Z",
    fill: "url(#paint4_linear_7761_84917)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_7761_84917",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 489,
    width: 44,
    height: 44
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6706 525.164C53.5237 516.479 52.8492 503.072 44.1642 495.219C35.4791 487.366 22.0723 488.041 14.2192 496.726C6.36616 505.411 7.04065 518.818 15.7257 526.671C24.4108 534.524 37.8175 533.849 45.6706 525.164Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_7761_84917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.3966 525.626C44.4947 517.982 45.4423 509.258 47.9091 500.942C50.3442 492.657 51.7629 485.559 49.3278 477.168C47.6021 471.287 38.5764 474.156 40.3339 480.075C43.1395 489.915 37.9306 498.2 36.7819 507.766C35.8025 515.949 36.9513 523.927 41.4826 530.862C44.6959 535.801 52.7104 530.724 49.3966 525.621V525.626Z",
    fill: "url(#paint5_linear_7761_84917)"
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M811.398 82.1367C811.398 84.503 811.298 86.9063 811.097 89.2725C810.896 91.2682 810.589 93.1263 810.319 95.122C807.545 110.574 799.906 124.846 788.509 135.666C777.112 146.555 762.639 153.521 746.985 155.581C731.332 157.677 715.472 154.702 701.709 147.159C687.945 139.615 676.824 127.916 670.095 113.65C668.1 109.59 666.612 105.228 665.432 100.866C664.923 99.0711 664.553 97.213 664.246 95.3179C663.838 92.9516 663.468 90.6542 663.267 88.1821C662.557 79.9663 663.267 71.6447 665.363 63.5984C665.972 61.3327 666.649 59.1358 667.459 56.8702C668.237 54.7739 669.047 52.8099 669.926 50.8195C670.434 49.7396 671.006 48.6544 671.514 47.5375C677.671 35.738 686.966 25.8283 698.263 18.793C709.559 11.7578 722.645 8.00457 735.932 7.80341C749.325 7.60225 762.411 10.9796 773.972 17.5067C785.571 24.1343 795.073 33.7687 801.732 45.3671C802.812 47.3628 803.897 49.3214 804.808 51.4177C805.687 53.514 806.602 55.7797 807.375 57.9448C810.012 65.8905 811.398 73.9051 811.398 82.1208V82.1367Z",
    fill: "url(#paint6_linear_7761_84917)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M778.498 62.4226C795.745 62.4226 809.71 48.458 809.71 31.2113C809.71 13.9646 795.745 0 778.498 0C761.252 0 747.287 13.9646 747.287 31.2113C747.287 48.458 761.252 62.4226 778.498 62.4226Z",
    fill: "url(#paint7_linear_7761_84917)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7761_84917",
    x1: 334.37,
    y1: 541.95,
    x2: 349.762,
    y2: 525.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D2B79",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#094672",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7761_84917",
    x1: 70.9927,
    y1: 238.696,
    x2: 99.7732,
    y2: 207.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D2B79",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#094672",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7761_84917",
    x1: 9.72324,
    y1: 490.438,
    x2: 39.3691,
    y2: 531.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#569DD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344A9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7761_84917",
    x1: -1.00396,
    y1: 496.863,
    x2: 32.813,
    y2: 543.222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#569DD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#5292CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#4675B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344A9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7761_84917",
    x1: 12.9683,
    y1: 494.721,
    x2: 47.3185,
    y2: 541.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#569DD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#5292CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#4675B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344A9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7761_84917",
    x1: 29.1003,
    y1: 484.25,
    x2: 58.4111,
    y2: 524.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#569DD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#5292CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#4675B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344A9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7761_84917",
    x1: 629.405,
    y1: 106.949,
    x2: 816.1,
    y2: 60.8398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#163A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7761_84917",
    x1: 758.905,
    y1: 51.6376,
    x2: 812.224,
    y2: -6.70937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D2B79",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#094672",
    stopOpacity: 0.05
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlide3Planets);
export default __webpack_public_path__ + "static/media/slide_3_planets.6a2ec6a01078be5daef4a282f6d06914.svg";
export { ForwardRef as ReactComponent };